import './flip-slider.scss';
import Swiper from 'swiper/bundle';
export default () => {
	new Swiper('.js-flip-swiper', {
		effect: "coverflow",
		grabCursor: true,
		centeredSlides: true,
		initialSlide: 2,
		slidesPerView: 'auto',
		loop: true,
		coverflowEffect: {
			rotate: 0,
			stretch: 250,
			depth: 400,
			modifier: 2,
			slideShadows: false,
		},
		navigation: {
			prevEl: ".flip-prev",
			nextEl: ".flip-next",
		},
	});
};
